import React from "react";
import styles from "./prescription-listing-actions.module.scss";
import { Stack } from "@mui/system";
import { IconButton, Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";
import Icon from "../../../components/Icon/Icon";

const PrescriptionListingActions = ({handlePdfView, handleEditFile, downloadFile, setDeletedFileName, setFileDeleted, item}) => {
  const quotefileStoredName = item?.stored_name?.includes("PACE/Quotes");
  const { t } = useTranslation();
  return (
    <div className={styles.PrescriptionListingActions} data-testid="PrescriptionListingActions">
      <Stack container direction="row" className={styles.buttonStyling}>
        <Tooltip
          title={
            <span className={styles.tooltipFontSize}>
              {t("Prescriptions.viewDocument")}
            </span> }
        >
          <IconButton
            className="marginLeftEight"
            color="success"
            data-testid="ViewDocument"
            onClick={() => handlePdfView(item)}
          >
            <Icon icon="fa-eye" />
          </IconButton>
        </Tooltip>

        {!quotefileStoredName && <Tooltip
          title={
            <span className={styles.tooltipFontSize}>
              {t("Prescriptions.editDocument")}
            </span>
          }
        >
          <IconButton
            className="marginLeftEight"
            color="secondary"
            data-testid="Edit"
            onClick={() => {
              handleEditFile(item)
            }}
          >
            <Icon icon="fa-pencil" />
          </IconButton>
        </Tooltip>
        }
        <Tooltip
          title={
            <span className={styles.tooltipFontSize}>
              {t("Prescriptions.downloadDocument")}
            </span>
          }
        >
          <IconButton
            className="marginLeftEight"
            color="primary"
            data-testid="DownloadDocument"
            onClick={() => downloadFile(item)}
          >
            <Icon icon="fa-arrow-down-to-bracket" />
          </IconButton>
        </Tooltip>
        {!quotefileStoredName && <Tooltip
          title={
            <span className={styles.tooltipFontSize}>
              {t("Prescriptions.removeDocument")}
            </span>
          }
        >
          <IconButton
            className="marginLeftEight"
            color="error"
            data-testid="Delete"
            onClick={(e) => {
              e.preventDefault();
              setDeletedFileName(`Are you sure you want to remove the document ${item?.display_name ?? ""}?`);
              setFileDeleted(item);
            }}
          >
            <Icon icon="fa-trash" />
          </IconButton>
        </Tooltip>}
      </Stack>
    </div>
  );
};

export default PrescriptionListingActions;
